<script lang="ts">
	import type { ProductForCard } from "@components/ProductCard.js";
	import ProductCard from "@components/ProductCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { SubcategoryForCustomer } from "@core/schema/Subcategory.js";
	import translations from "./ProductB2cListingGrid.translations.json" with { type: "json" };

	const {
		products,
		subcategories,
	}: {
		products: ProductForCard[];
		subcategories: SubcategoryForCustomer[];
	} = $props();

	const translate = getTranslate(translations);
</script>

<div class="grid gap-4 gap-y-20 justify-center grid-cols-[repeat(auto-fill,20.375rem)]">
	{#each products as product (product)}
		{@const subcategory = subcategories.find(({ id }) => id === product.subcategoryId)}
		{#if subcategory}
			<ProductCard {product} {subcategory} />
		{/if}
	{:else}
		<div class="text-fcrdarkgray col-span-full text-center my-5">
			<Formatted text={translate("noProducts")} />
		</div>
	{/each}
</div>
